export enum MKPlatformType {
    Desktop = "desktop",
    Mobile = "mobile"
}